import {
  INVENTORY_PLATFORM_LABELS,
  INVENTORY_PLATFORMS
} from "@/domain/ai-inventory"
import {
  getInputFilter,
  getMultipleValuesFilter,
  withDisplayLabel
} from "@/helpers/filters.helper"
import { AI_POLICY_KINDS } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"
import {
  DECISIONS_POLICY_KIND_PARAM,
  DECISIONS_POLICY_PARAM
} from "../../const"

import type { TFunction } from "@/hooks/useTranslation"
import type { AiPolicySelectOption } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.types"

const LABELS = "governance.ai.live.filters"
const LIVE = "governance.ai.live"

// What enforced a violation, as the API names it
const ENFORCED_BY = ["interceptor", "cedar", "webhook", "sensor"] as const

// The filters the API narrows the violations by, keyed as DECISIONS_FILTER_KEYS.
// The decisions are violations only, so a violation is either blocked or would
// have been; the action is the same as the decision, so it has no filter
export const getDecisionsFilters = (
  t: TFunction,
  options: {
    policies: { id: string; name: string }[]
    agents: AiPolicySelectOption[]
  }
) =>
  [
    getMultipleValuesFilter(DECISIONS_POLICY_PARAM, t, {
      label: `${LABELS}.policy`,
      options: options.policies.map(({ id, name }) => ({
        value: id,
        label: name
      }))
    }),
    getMultipleValuesFilter(DECISIONS_POLICY_KIND_PARAM, t, {
      label: `${LABELS}.policyKind`,
      options: AI_POLICY_KINDS.map((kind) => ({
        value: kind,
        label: t(`${LABELS}.kinds.${kind}`)
      }))
    }),
    getMultipleValuesFilter("platform", t, {
      label: `${LABELS}.platform`,
      options: INVENTORY_PLATFORMS.map((platform) => ({
        value: platform,
        label: INVENTORY_PLATFORM_LABELS[platform]
      }))
    }),
    getMultipleValuesFilter("agentId", t, {
      label: `${LABELS}.agent`,
      options: options.agents.map(({ value, label }) => ({ value, label }))
    }),
    getInputFilter("tool", t, { label: `${LABELS}.toolName` }),
    getMultipleValuesFilter("outcome", t, {
      label: `${LABELS}.decision`,
      options: (["blocked", "wouldBlock"] as const).map((outcome) => ({
        value: outcome,
        label: t(`${LIVE}.decisions.outcomes.${outcome}`)
      }))
    }),
    getMultipleValuesFilter("enforcedBy", t, {
      label: `${LABELS}.enforcedBy`,
      options: ENFORCED_BY.map((enforcer) => ({
        value: enforcer,
        label: t(`${LIVE}.violationLog.enforcedBy.${enforcer}`)
      }))
    })
  ].map(withDisplayLabel)
